import { IconButton, Tooltip } from '@mui/material'
import React from 'react'
import clsx from 'clsx'
import { useTranslation } from '../../../../../common/hooks'
import dayjs from 'dayjs'
import { EditOutlined as EditOutlinedIcon } from '@mui/icons-material'
import {
  BetmenListItemCard,
  BetmenListItemCardCell,
} from '../../../../../common/components'
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined'
import { TreatmentSurveyItemComponentViewModel } from '../../types/treatmentItem.types'
import { useExtraBetmenListItemCardStyle } from '../../../../../utils'
import { useTreatmentPanelData } from '../TreatmentPanel/TreatmentPanelProvider'

interface Props {
  vm: TreatmentSurveyItemComponentViewModel
}

export const TreatmentSurveyCard: React.FC<Props> = ({ vm }) => {
  const { survey, onClick, editSurvey } = vm

  const {
    isOwnTreatment,
    isAssistantOfTreatment,
    isTreatmentDraft,
    setHoveredTreatmentItem,
  } = useTreatmentPanelData()

  const classes = useExtraBetmenListItemCardStyle()

  const { t } = useTranslation()

  const date = survey.fillableFrom
  const isPast = dayjs().startOf('day') > dayjs(date)
  const dateString = t('common:intlDateFormatted', { date })
  const canEditSurvey =
    (isOwnTreatment || isAssistantOfTreatment) && (!isPast || isTreatmentDraft)

  return (
    <BetmenListItemCard
      className={clsx(classes.container, {
        [classes.past]: isPast,
      })}
      mb={1}
      pl={2}
      pr={1}
      onMouseEnter={() => {
        setHoveredTreatmentItem({
          id: survey.id,
          date: dayjs(survey.fillableFrom),
        })
      }}
      onMouseLeave={() => {
        setHoveredTreatmentItem(null)
      }}
      onClick={() => onClick(survey)}
    >
      <BetmenListItemCardCell gridSize={1}>
        <FactCheckOutlinedIcon fontSize="large" />
      </BetmenListItemCardCell>
      <BetmenListItemCardCell gridSize={4}>
        {survey?.surveySchema?.title}
      </BetmenListItemCardCell>

      <BetmenListItemCardCell
        gridSize={3}
        typographyProps={{ fontWeight: 400 }}
      >
        {t('common:formattedNameFull', survey.doctor)}
      </BetmenListItemCardCell>

      <BetmenListItemCardCell
        gridSize={3}
        typographyProps={{ fontWeight: 400 }}
      >
        {dateString}
      </BetmenListItemCardCell>

      <BetmenListItemCardCell
        gridSize={1}
        display="flex"
        justifyContent="flex-end"
      >
        {canEditSurvey && (
          <Tooltip
            title={t('doctor:tooltips.edit-survey') as string}
            enterDelay={500}
            leaveDelay={200}
          >
            <IconButton
              onClick={(ev) => {
                ev.stopPropagation()
                editSurvey(survey)
              }}
              size="large"
            >
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
        )}
      </BetmenListItemCardCell>
    </BetmenListItemCard>
  )
}
